import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import BgImg from "../../assets/portfolio/bg2.png";
import ServiceSide from "./ServiceSide";
import ECommerceHero from "../../assets/service/e-commerce-hero.png";
import ECommerceImage from "../../assets/service/e-commerce.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faShoppingCart,
  faCreditCard,
  faTruck,
  faChartLine,
  faGlobe,
  faHandHoldingUsd,
  faClock,
  faThumbsUp,
} from "@fortawesome/free-solid-svg-icons";
import FaqECommerce from "../ServiceImp/FaqECommerce";
import { Helmet } from "react-helmet-async";
const ECommerce = () => {
  useEffect(() => {
    AOS.init({ duration: 1000, once: true }); // Initialize AOS with animation duration and animation trigger once
  }, []);

  const pillars = [
    {
      icon: faShoppingCart, // Icon for E-commerce Management
      title: "E-commerce Management",
      description:
        "Manage products, inventory, and pricing seamlessly with robust e-commerce tools.",
      bgColor: "bg-green-100",
    },
    {
      icon: faCreditCard, // Icon for Payment Processing
      title: "Payment Processing",
      description:
        "Secure and fast payment gateways supporting multiple payment methods.",
      bgColor: "bg-blue-100",
    },
    {
      icon: faTruck, // Icon for Order Fulfillment
      title: "Order Fulfillment",
      description:
        "Streamline order processing, shipping, and delivery with real-time tracking.",
      bgColor: "bg-purple-100",
    },
    {
      icon: faChartLine, // Icon for Analytics & Insights
      title: "Analytics & Insights",
      description:
        "Gain actionable insights with real-time analytics and sales performance tracking.",
      bgColor: "bg-orange-100",
    },
  ];

  const benefits = [
    {
      icon: faGlobe, // Icon for Global Reach
      title: "Global Reach",
      description:
        "Expand your business globally, reaching customers anywhere, anytime.",
      bgColor: "bg-green-100",
    },
    {
      icon: faHandHoldingUsd, // Icon for Cost Efficiency
      title: "Cost Efficiency",
      description:
        "Reduce operational costs with automated inventory, order processing, and digital transactions.",
      bgColor: "bg-blue-100",
    },
    {
      icon: faClock, // Icon for 24/7 Availability
      title: "24/7 Availability",
      description:
        "Your store remains open 24/7, enabling customers to shop at their convenience.",
      bgColor: "bg-yellow-100",
    },
    {
      icon: faThumbsUp, // Icon for Enhanced Customer Experience
      title: "Enhanced Customer Experience",
      description:
        "Deliver a seamless shopping experience with easy navigation, secure checkout, and fast delivery.",
      bgColor: "bg-red-100",
    },
  ];
  // seo
  const schemas = [
    // 1. Organization (Main)
    {
      "@context": "http://schema.org",
      "@type": "Organization",
      name: "Deetya Soft Pvt Ltd",
      description:
        "Deetyasoft offers expert e-commerce services to build powerful, secure, and user-friendly online stores that drive sales and grow your digital business.",
      image:
        "https://www.deetyasoft.com/static/media/e-commerce.0b2c770cef152ad499e6.png",
      logo: "https://www.deetyasoft.com/images/logo.png",
      url: "https://www.deetyasoft.com",
      telephone: ["+91-9015350505", "+91-9717055088"],
      email: "info@deetyasoft.com",
      sameAs: [
        "https://www.linkedin.com/company/deetya-soft-private-limited",
        "https://www.facebook.com/deetyasoftprivatelimited",
        "https://www.instagram.com/deetyasoft",
        "https://www.youtube.com/@deetyasoft",
        "https://www.crunchbase.com/organization/deetyasoft",
      ],
      address: {
        "@type": "PostalAddress",
        streetAddress:
          "FF‑06, First Floor, Mahaluxmi Square, Plot No. C‑1, Abhay Khand II, Indirapuram",
        addressLocality: "Ghaziabad",
        addressRegion: "Uttar Pradesh",
        postalCode: "201014",
        addressCountry: "IN",
      },
    },

    // 2. Organization Contact Points
    {
      "@context": "http://schema.org",
      "@type": "Organization",
      url: "https://www.deetyasoft.com",
      contactPoint: [
        {
          "@type": "ContactPoint",
          telephone: "+91-981-862-7588",
          contactType: "technical support",
          areaServed: "IN",
        },
        {
          "@type": "ContactPoint",
          telephone: "+91-901-535-0505",
          contactType: "sales",
          areaServed: "IN",
        },
      ],
    },

    // 3. Review
    {
      "@context": "http://schema.org",
      "@type": "Review",
      author: {
        "@type": "Person",
        name: "Parshan",
      },
      reviewBody:
        "Deetya Soft helps companies to enable effective business operations through custom web solutions, IVR, and cloud telephony services.",
      url: "https://www.deetyasoft.com/",
      description:
        "Deetya Soft Pvt Ltd offers services such as IVR systems, virtual phone numbers, toll-free numbers, call tracking, enquiry management, LMS, web solutions, VOIP, and cloud-based communication solutions.",
      datePublished: "2025-06-17",
      name: "Deetya Soft Pvt Ltd",
      reviewRating: {
        "@type": "Rating",
        worstRating: "1",
        ratingValue: "5",
        bestRating: "5",
      },
      itemReviewed: {
        "@type": "Organization",
        name: "Deetya Soft Pvt Ltd",
      },
    },

    // 4. FAQ Page
    {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: [
        {
          "@type": "Question",
          name: "What is an e-commerce platform?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "An e-commerce platform includes websites and mobile application that allows businesses to buy and sell products or services online. It typically includes features for managing inventory, processing payments, handling customer accounts, and facilitating communication between buyers and sellers.",
          },
        },
        {
          "@type": "Question",
          name: "Is there any difference between an e-commerce website and an e-commerce app?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Yes, an e-commerce website is accessed through a browser, while an e-commerce app is a software application designed specifically for mobile devices (iOS/Android), offering features optimized for mobile shopping experiences",
          },
        },
        {
          "@type": "Question",
          name: "Why should I choose Deetya soft for an e-commerce platform for my business?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "We, at Deetya soft have a team of experts who will assist you in providing an e-commerce platform as per your business requirements, which helps ultimately in streamline the selling process, expand your reach to a global audience, provide better customer experience, automate tasks like payment processing, and support various marketing and customer engagement strategies.",
          },
        },
        {
          "@type": "Question",
          name: "What are the key features of an e-commerce platform?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Key features of an e-commerce platform include product catalogue, shopping cart, payment gateway, order management, customer accounts, inventory management, product search, secure payment options, and customer support.",
          },
        },
        {
          "@type": "Question",
          name: "How can I ensure the security of my e-commerce platform?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Ensure data encryption (SSL), use secure payment gateways, adhere to PCI DSS standards, implement two-factor authentication, and regularly update security protocols to protect user data and transactions.",
          },
        },
        {
          "@type": "Question",
          name: "How can I integrate social media with my e-commerce platform?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Yes, off course you can, social media integration allows your customers to share products, reviews, or their shopping experiences directly to platforms like Instagram, Facebook, or Twitter. It also supports social login features for easier user registration.",
          },
        },
        {
          "@type": "Question",
          name: "How can I optimize my e-commerce app for mobile devices?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Ensure your app is mobile-responsive, loads quickly, has an intuitive interface, and integrates mobile payment systems. Additionally, optimize images and reduce unnecessary features to improve performance.",
          },
        },
      ],
    },
  ];
  return (
    <>
      {/* seo */}
      <Helmet>
        <title>
          E-Commerce Services | Boost Your Online Store with Deetyasoft
        </title>
        <meta
          name="description"
          content="Deetyasoft offers expert e-commerce services to build powerful, secure, and user-friendly online stores that drive sales and grow your digital business."
        />
        <meta
          name="keywords"
          content="e-commerce solutions, e-commerce marketing, Online store solutions, e-commerce services, e-commerce development company,  online store development, e-commerce website design, secure payment integration, e-commerce SEO services, customized e-commerce solutions,  Deetyasoft e-commerce, e-commerce services India, shopping website development services, e-commerce development company,  online store development,"
        />
        <link
          rel="canonical"
          href="https://deetyasoft.com/e-commerce-services"
        />

        {/* <!-- Facebook Meta Tags --> */}
        <meta property="og:locale" content="en_IN" />
        <meta property="og:type" content="article" />
        <meta
          property="og:url"
          content="https://deetyasoft.com/e-commerce-services"
        />
        <meta
          property="og:title"
          content="E-Commerce Services | Boost Your Online Store with Deetyasoft"
        />
        <meta
          property="og:description"
          content="Deetyasoft offers expert e-commerce services to build powerful, secure, and user-friendly online stores that drive sales and grow your digital business."
        />
        <meta
          property="og:image"
          content="https://deetyasoft.com/static/media/e-commerce.0b2c770cef152ad499e6.png"
        />
        <meta property="og:site_name" content="deetyasoft.com" />
        <meta
          property="article:publisher"
          content="https://www.facebook.com/deetyasoftprivatelimited"
        />

        {/* <!-- Twitter Meta Tags --> */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:url"
          content="https://deetyasoft.com/e-commerce-services"
        />
        <meta
          name="twitter:title"
          content="E-Commerce Services | Boost Your Online Store with Deetyasoft"
        />
        <meta
          name="twitter:description"
          content="Deetyasoft offers expert e-commerce services to build powerful, secure, and user-friendly online stores that drive sales and grow your digital business."
        />
        <meta
          name="twitter:image"
          content="https://deetyasoft.com/static/media/e-commerce.0b2c770cef152ad499e6.png"
        />
        <meta name="twitter:site" content="@DeetyaSoft" />
        <meta name="twitter:creator" content="@DeetyaSoft" />

        <meta
          name="google-site-verification"
          content="RfVxHwAy-Zv_s_VZjaK7Dyqb84AGXX7y8MdkaGLItD4"
        />
        <meta name="yandex-verification" content="31c730ea93a5a9cd" />
        <meta name="copyright" content="Deetyasoft" />
        <meta name="author" content="Deetyasoft" />
        <meta name="email" content="info@deetyasoft.com" />
        <meta name="Distribution" content="Global" />
        <meta name="rating" content="general" />
        <meta name="robots" content="index, follow" />
        <meta name="googlebot" content="index, follow" />
        <meta property="bingbot" content="index, follow " />
        <meta name="Yahoobot" content="index, follow" />
        <meta name="MSNbot" content="index, follow" />
        <meta name="googlebot-news" content="index, follow" />
        <meta name="audience" content="all" />
        <meta name="geo.placename" content="Noida, Uttar Pradesh, India" />
        <meta name="geo.region" content="IN-UP" />
        <meta name="geo.position" content="28.644800;77.373300" />
        <meta name="ICBM" content="28.644800, 77.373300" />
        <link rel="alternate" href="https://deetyasoft.com" hreflang="en-us" />
        <meta http-equiv="content-language" content="en-us" />
        <meta name="msvalidate.01" content="305155CCD42FD63B0A29555BBEE7CA03" />

        {/* <!-- Id+json scripts --> */}
        {schemas?.map((schema, i) => (
          <script
            key={i}
            type="application/ld+json"
            dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
          />
        ))}
      </Helmet>

      <div className="relative bg-[#2f68a2] overflow-hidden pb-5 text-white">
        {/* Content */}
        <div className="relative z-20 max-w-7xl mx-auto  px-6 py-10 grid md:grid-cols-2 lg:gap-20 md:gap-10  items-start">
          {/* Left Side */}
          <div>
            <h1 className="text-3xl md:text-4xl font-bold leading-snug mb-4">
              E-Commerce platform
            </h1>
            <p className="text-white/90 mb-6 text:base md:text-lg">
              E-commerce is now a cornerstone for modern businesses, offering
              convenience, global reach, and cost-effective solutions. As
              consumer expectations evolve, companies embracing digital shopping
              are thriving, reaching wider audiences, and delivering seamless
              experiences. The future of business is online—grow with it.
            </p>
            <button
              className="bg-orange-500   hidden md:block hover:bg-orange-600 text-white px-5 py-3 rounded shadow-md transition"
              onClick={() => {
                const target = document.getElementById("bottomTarget");
                if (target) {
                  target.scrollIntoView({ behavior: "smooth", block: "start" });
                  // Optional offset tweak using window.scrollBy
                  setTimeout(() => {
                    window.scrollBy(0, -100); // scrolls 100px up after reaching the section
                  }, 600);
                }
              }}
            >
              Let's Get Started
            </button>
          </div>

          {/* Right Side Image */}
          <div className="flex justify-center">
            <img
              src={ECommerceHero}
              alt="E-commerce"
              className="md:w-[90%] object-contain w-full  max-w-lg animate-float"
            />
          </div>
        </div>

        {/* FIRST CURVE - White */}
        <div className="absolute bottom-0 left-0 w-full z-10">
          <svg
            className="w-full h-auto"
            viewBox="0 0 1440 290"
            preserveAspectRatio="none"
          >
            <path
              fill="#ffffff"
              fillOpacity="1"
              d="M0,160L60,165.3C120,171,240,181,360,165.3C480,149,600,107,720,117.3C840,128,960,192,1080,208C1200,224,1320,192,1380,176L1440,160L1440,320L1380,320C1320,320,1200,320,1080,320C960,320,840,320,720,320C600,320,480,320,360,320C240,320,120,320,60,320L0,320Z"
            />
          </svg>
        </div>

        {/* SECOND CURVE - Light Blue */}
        <div className="absolute bottom-[20px] left-0 w-full z-0">
          <svg
            className="w-full h-auto"
            viewBox="0 0 1440 320"
            preserveAspectRatio="none"
          >
            <path
              fill="#a6c7e2" // Light blue like in the image
              fillOpacity="1"
              d="M0,288L60,272C120,256,240,224,360,197.3C480,171,600,149,720,160C840,171,960,213,1080,208C1200,203,1320,149,1380,122.7L1440,96L1440,320L1380,320C1320,320,1200,320,1080,320C960,320,840,320,720,320C600,320,480,320,360,320C240,320,120,320,60,320L0,320Z"
            />
          </svg>
        </div>
      </div>

      {/* second section is here */}

      <div className="md:py-5  py-1 ">
        <h2 className="text-xl px-2 md:px-0 md:text-3xl font-bold text-center mt-4 mb-2 text-gray-600">
          E-Commerce platform
        </h2>
        <div className="md:w-40 w-20 h-1 bg-main mx-auto md:mb-3 mb-1 rounded-full" />

        <p className="text-center text-gray-700 px-4 md:px-20 lg:px-40">
          Streamline your stock, reduce costs, and ensure products are always
          available when needed.
        </p>

        {/* Wrapper that allows scrolling */}
        <div className="  md:px-5 sm:px-3 grid grid-cols-1 md:grid-cols-1 lg:grid-cols-[2fr_1fr] gap-3 sm:gap-2 md:gap-8">
          {/* Main Content */}
          <div className="container mx-auto px-4 py-8">
            <div className="grid grid-cols-1 md:grid-cols-1 gap-8">
              {/* Image Section */}

              <div className="w-full md:order-1 order-2 max-w-2xl mx-auto px-4 sm:px-6 lg:px-8">
                <img
                  src={ECommerceImage}
                  alt="ECommerce"
                  className="w-full h-full  object-cover"
                />
              </div>

              {/* Text Content Section */}

              <div className="space-y-2 md:text-base text-sm order-2 md:order-1 text-justify">
                {/* Heading */}
                <h1 className="md:text-3xl text-xl font-bold text-main">
                  The Power of E-commerce in Modern Business
                </h1>

                {/* Introduction Section */}
                <p className="text-gray-600">
                  E-commerce has become an integral part for individual and
                  modern business. Dependency over E-commerce has widely grown
                  not just because of its convenience and cost-effectiveness but
                  also due to its role in global expansion, marketing
                  strategies, and shifting consumer expectations. The transition
                  to digital shopping is accelerating, and businesses that
                  embrace e-commerce are better positioned for growth and
                  long-term success. Whether large or small, e-commerce enables
                  businesses to reach a wider audience, operate more
                  efficiently, and offer enhanced customer experiences. As
                  technology continues to evolve, the dependence on e-commerce
                  will only continue to grow.
                </p>

                {/* Subheading */}
                <h2 className="md:text-3xl text-xl font-semibold text-main">
                  The Importance of an E-commerce Platform
                </h2>

                {/* Platform Importance Section */}
                <p className="text-gray-600">
                  An e-commerce platform is essential for running a successful
                  online business. It provides businesses with the tools
                  necessary to manage inventory, handle transactions, interact
                  with customers, and market products effectively.
                </p>
                <p className="text-gray-600">
                  Choosing the right platform depends on factors like your
                  business size, customization needs, and budget, levels of
                  flexibility and features to accommodate businesses from
                  startups to large enterprises. E-commerce platform can be in
                  the form of website that can be accessed through a browser or
                  in the form of mobile application designed specifically for
                  mobile devices (iOS/Android).
                </p>

                {/* List of Platform Types */}
                <ul className="list-disc list-inside space-y-2 pl-2 text-gray-600">
                  <li>
                    <strong>Web-based Platforms:</strong> Accessible through a
                    browser.
                  </li>
                  <li>
                    <strong>Mobile Applications:</strong> Designed specifically
                    for mobile devices (iOS/Android).
                  </li>
                </ul>

                {/* Subheading */}
                <h2 className="text-2xl font-semibold text-main">
                  Our Expertise in E-commerce Development
                </h2>

                {/* Expertise Section */}
                <p className="text-gray-600">
                  We, at <span className="font-semibold">Deetya Soft</span>,
                  assist in developing an e-commerce platform using open-source
                  solutions like <span className="font-semibold">Magento</span>{" "}
                  and custom-built solutions like{" "}
                  <span className="font-semibold">PHP, ASP.NET, and JAVA</span>.
                  As a leading e-commerce development company, we are ready to
                  give the best in the world of Web Development.
                </p>
                <p className="text-gray-600 leading-relaxed">
                  Every business is different from its size, nature, business
                  objectives and hence developing the website for each involves
                  different methodology, a different approach, and sometimes
                  different technology/platform as well. At Deetya Soft, we
                  understand your business's requirement before starting the
                  work on it, then after analyzing all the requirements, we
                  suggest the best fit platform for developing the website.
                </p>
                <p className="text-gray-600 text-lg leading-relaxed">
                  As the e-commerce websites are directly involved in monetary
                  transactions, hence the{" "}
                  <span className="font-semibold">security</span> aspects of
                  these websites need to be quite strong so that customers may
                  feel secure while doing transactions on the website. The
                  online payment gateway integrated with the website should be{" "}
                  <span className="font-semibold">
                    user-friendly and hassle-free
                  </span>
                  . Deetya Soft ensures the fast loading of the website also
                  making sure that the images displayed are of good quality and
                  may not slow down the website.
                </p>

                {/* Closing Statement */}
                <p className="text-gray-600">
                  At <span className="font-bold">Deetya Soft</span>, we not only
                  build e-commerce solutions; we build{" "}
                  <span className="font-semibold">trust and growth</span>. Let
                  us help you take your business to the next level with a
                  powerful, secure, and user-friendly online store.
                </p>
              </div>
            </div>
          </div>
          {/* Sticky Sidebar */}
          <div className="sticky md:block hidden  top-20 self-start  p-3  h-fit">
            <ServiceSide />
          </div>
        </div>

        {/* make it next section */}

        <div
          className="py-5 px-5 relative"
          // data-aos='fade-up'
          style={{
            backgroundImage: `url(${BgImg})`,
            backgroundRepeat: "repeat",
            backgroundSize: "auto",
            backgroundPosition: "center",
            backgroundAttachment: "fixed",
            minHeight: "60vh",
          }}
        >
          <div className="text-center py-10 px-4">
            <h2 className="text-3xl md:text-4xl font-semibold">
              <span className="text-black">E-commerce</span>
              <span className="text-sky-500"> Feature</span>
            </h2>

            <div className="relative w-fit mx-auto mt-2">
              <div className="h-[1px] bg-gray-400 md:w-[200px] w-[100px] mx-auto"></div>
              <div className="absolute left-1/2 -translate-x-1/2 -top-[1px] flex gap-2">
                <div className="w-8 h-[2px] bg-sky-500"></div>
                <div className="w-8 h-[2px] bg-sky-500"></div>
              </div>
            </div>

            <p className="text-gray-800 text-base mt-4">
              What You Get Using Our Inventory Management System
            </p>
          </div>

          <div className="container mx-auto px-4 pb-4">
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
              {pillars.map((pillar, index) => (
                <div
                  key={index}
                  className="bg-gray-50 shadow-md  overflow-hidden hover:shadow-lg transition-shadow duration-300"
                >
                  <div className="p-8 text-center">
                    <div
                      className={`w-16 h-16 flex items-center justify-center rounded-full ${pillar.bgColor} mb-4 mx-auto`}
                    >
                      <FontAwesomeIcon
                        icon={pillar.icon}
                        className="text-sky-500 text-2xl"
                      />
                    </div>
                    <h5 className="md:text-lg text-base font-semibold text-gray-800 mb-3">
                      {pillar.title}
                    </h5>
                    <p className="text-gray-600 text-sm">
                      {pillar.description}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
        {/* benifits section is here */}
        <div className="bg-gray-50 py-12">
          <div className="max-w-7xl mx-auto px-4">
            <div className="text-center mb-8">
              <h2 className="text-3xl font-semibold text-mai">
                Benefits of E-Commerce
              </h2>
              <div className="w-40 h-1 bg-main1 mx-auto mt-2 rounded-full"></div>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
              {benefits.map((benefit, index) => (
                <div
                  key={index}
                  className="bg-white text-center shadow-md rounded-lg p-6 hover:shadow-lg transition duration-300"
                >
                  <div className="text-main text-5xl mb-4">
                    <FontAwesomeIcon icon={benefit.icon} />
                  </div>
                  <h5 className="text-lg font-bold mb-2">{benefit.title}</h5>
                  <p className="text-gray-600 text-sm">{benefit.description}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
        <div id="bottomTarget">
          <FaqECommerce />
        </div>
      </div>
    </>
  );
};

export default ECommerce;
